import React, { FC, useCallback } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import Button from '@cld/button';
import { Icon } from '@cld/icon';
import { CollapsibleSection } from '@cld/widget-demos-common';
import { setExported, updateOptions } from '../../../../actions';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';
import { optionsInitialState } from '../../../../reducers/options';
import { useWidget } from '../../../../selectors';
import { goToFirstAvailableStep } from '../../../../services/widget-service';
import { Themes } from './Themes';

export const General: FC = () => {
  const analytics = useAnalytics();
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const widget = useWidget();

  const handleReset = useCallback(() => {
    analytics('edit general', 'reset');
    dispatch(updateOptions(optionsInitialState));
    dispatch(setExported({ isExported: false }));
    goToFirstAvailableStep(widget.instance);
  }, [analytics, dispatch, widget.instance]);

  return (
    <CollapsibleSection title={formatMessage(messages['section.general'])}>
      <Button variant="secondary" size="sm" onClick={handleReset} data-test="reset-button">
        <Icon name="reset" />
        <FormattedMessage {...messages['section.general.reset']} />
      </Button>
      <Themes />
    </CollapsibleSection>
  );
};
